<template>
	<v-navigation-drawer app permanent right clipped width="20vw" fixed>
		<template v-slot:prepend>
			<v-list-item two-line>
				<v-list-item-avatar>
					<v-icon>mdi-cart</v-icon>
				</v-list-item-avatar>

				<v-list-item-content>
					<v-list-item-title>{{
						$t("label.cart")
					}}</v-list-item-title>
					<v-list-item-subtitle
						>{{ cart.count }}-{{
							$t("label.item_in_cart")
						}}</v-list-item-subtitle
					>
				</v-list-item-content>
			</v-list-item>
		</template>
		<v-divider></v-divider>
		<v-list dense two-line>
			<v-list-item v-for="(item, index) in cart.items" :key="index">
				<v-list-item-action>
					<v-img
						:src="item.image_url"
						width="50"
						height="50"
						rounded
					></v-img>
				</v-list-item-action>
				<v-list-item-content>
					<v-list-item-title>
						<v-btn icon x-small @click="removeCartItem(item)"
							><v-icon>mdi-minus</v-icon></v-btn
						>
						{{ item.quantity }}
						<v-btn icon x-small @click="addCartItem(item)"
							><v-icon>mdi-plus</v-icon></v-btn
						>
					</v-list-item-title>
					<v-list-item-subtitle>
						<p>{{ item.name }}</p>
						<small v-if="item.note">
							<strong>{{ $t("label.note") }}:</strong>
							<i> {{ item.note }}</i>
						</small>
					</v-list-item-subtitle>
				</v-list-item-content>
				<v-list-item-action-text>
					{{ item.total }}
				</v-list-item-action-text>
			</v-list-item>
		</v-list>

		<template v-slot:append>
			<v-divider></v-divider>
			<v-list dense>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title>{{
							$t("label.initial")
						}}</v-list-item-title>
					</v-list-item-content>
					<v-list-item-action-text>{{
						cart.initial
					}}</v-list-item-action-text>
				</v-list-item>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title>{{
							$t("Discount")
						}}</v-list-item-title>
					</v-list-item-content>
					<v-list-item-action-text>{{
						cart.discount
					}}</v-list-item-action-text>
				</v-list-item>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title>{{
							$t("Subtotal")
						}}</v-list-item-title>
					</v-list-item-content>
					<v-list-item-action-text>{{
						cart.subtotal
					}}</v-list-item-action-text>
				</v-list-item>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title>{{
							$t("label.tax")
						}}</v-list-item-title>
					</v-list-item-content>
					<v-list-item-action-text>{{
						cart.tax
					}}</v-list-item-action-text>
				</v-list-item>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title>{{ $t("Total") }}</v-list-item-title>
					</v-list-item-content>
					<v-list-item-action-text>{{
						cart.total
					}}</v-list-item-action-text>
				</v-list-item>
			</v-list>
			<div class="pa-2">
				<Link
					as="v-btn"
					block
					color="primary"
					raised
					:href="
						$route('shop.' + type + '.checkout.index', {
							cart_uuid: cart.uuid,
						})
					"
				>
					<v-icon left>mdi-credit-card-outline</v-icon>
					{{ $t("label.checkout") }}
				</Link>
			</div>
		</template>
	</v-navigation-drawer>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
	props: ["outlet_uuid", "type"],
	data() {
		return {
			cart: {
				count: 0,
				discount: 0,
				initial: 0,
				items: [],
				shipping: 0,
				subtotal: 0,
				tax: 0,
				total: 0,
				uuid: null,
				weight: 0,
			},
		};
	},
	methods: {
		async getCart() {
			try {
				const { data } = await axios.get(
					this.$route("shop.carts.index"),
					{
						params: {
							instance: this.type,
							outlet_uuid: this.outlet_uuid,
						},
					}
				);
				if (data.success) {
					this.cart = data.data;
				}
			} catch (error) {
				this.$toast.error(error.message);
			}
		},

		async updateCartItem(uuid, quantity) {
			try {
				const { data } = await axios.put(
					this.$route("shop.carts.update", {
						cart: uuid,
						quantity: quantity,
					}),
					{
						params: {
							uuid: uuid,
							quantity: quantity,
						},
					}
				);
				if (data.success) {
					await this.getCart();
				}
			} catch (error) {
				this.$toast.error(error.message);
			}
		},

		async removeCartItem(item) {
			var quantity = item.quantity - 1;
			await this.updateCartItem(item.uuid, quantity);
		},

		async addCartItem(item) {
			var quantity = item.quantity + 1;
			await this.updateCartItem(item.uuid, quantity);
		},
	},
	async mounted() {
		await this.getCart();
	},
};
</script>